import { ConnectorType } from 'aws-sdk/clients/appflow'
import { AnnotationType } from 'components/AnnotationProject/types'
import { CSSProperties } from 'styled-components'
import { Annotation } from './Annotation'
const ymove = 6

const Labels = {
  bio: {
    drink: (
      <>
        <span>2cm</span>
        <br />
        Tränkeplatz&shy;breite
      </>
    ),
    weide: (
      <>
        <span>
          5m<sup>2</sup>
        </span>
        <br />
        Weideauslauf
      </>
    ),
    gitter: (
      <>
        <span>
          0,2m<sup>2</sup>
        </span>
        <br />
        Stallfläche
      </>
    ),
    scharr: (
      <>
        <span>33%</span>
        <br />
        der Stallfläche muss eingestreut sein
      </>
    ),
    klima: (
      <>
        <span>
          0,1m<sup>2</sup>
        </span>
        <br />
        Aussenklima&shy;bereich
      </>
    ),
    nest: (
      <>
        <span>5 Hühner</span>
        <br />
        teilen sich ein Einzelnest
      </>
    ),
    trog: (
      <>
        <span>16cm</span>
        <br />
        Fressplatzbreite
        <small>am Trog bei manueller Fütterung</small>
      </>
    ),
    stange: (
      <>
        <span>16cm</span>
        <br />
        Sitzstange pro Huhn
      </>
    ),
  },
  konv: {
    drink: (
      <>
        <span>1,5cm</span>
        <br />
        Tränkeplatz&shy;breite
      </>
    ),
    einstreu: (
      <>
        <span>
          20%
        </span>
        <br />
     der begehbaren Fläche muss eingestreut sein
      </>
    ),
    area: (
      <>
        <span>
          0,08m<sup>2</sup>
        </span>
        <br />
        begehbare Fläche
        <small>Gitter oder Rost- und Scharr&shy;flächen</small>
      </>
    ),
    nest: (
      <>
        <span>5 Hühner</span>
        <br />
        teilen sich ein Einzelnest
      </>
    ),
    eat: (
      <>
        <span>16cm</span>
        <br />
        Fressplatzbreite
        <small>am Trog bei manueller Fütterung</small>
      </>
    ),
    stange: (
      <>
        <span>14cm</span>
        <br />
        Sitzstange pro Huhn
      </>
    ),
  },
  eu: {
    drink: (
      <>
        <span>1cm</span>
        <br />
        Tränkeplatz&shy;breite
      </>
    ),
    area: (
      <>
        <span>
          0,1m<sup>2</sup>
        </span>
        <br />
        begehbare Fläche im Stall
      </>
    ),
    nest: (
      <>
        <span>7 Hühner</span>
        <br />
        teilen sich ein Einzelnest
      </>
    ),
    einstreu: (
      <>
        <span>33%</span>
        <br />
        der Stall&shy;fläche als Einstreu&shy;bereich
      </>
    ),
    eat: (
      <>
        <span>12cm</span>
        <br />
        Fressplatz&shy;breite
      </>
    ),
    stange: (
      <>
        <span>15cm</span>
        <br />
        Sitzstange pro Huhn
      </>
    ),
  },
}

export const getAnnotations_Huhn = (
  colorMode: 'light' | 'dark' = 'light',
  width: number,
  standards: 'eu' | 'konventionell' | 'bio'
) => {
  const connectorStyle =
    colorMode === 'light'
      ? { stroke: '#000', strokeWidth: 0.5 }
      : { stroke: '#fff', strokeWidth: 0.5 }
  const connector: {
    type: 'straight' | 'curved'
    style: CSSProperties
    offset: number
  } = { type: 'straight', style: connectorStyle, offset: 0 }
  const Annotations_Konventionell: AnnotationType[] = [
    {
      left: 38,
      top: 64 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.drink}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 54,
      top: 49 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 150 }}
        >
          {Labels.konv.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 57,
      top: 46 + ymove,
      distance: 120,

      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 82,
      top: 32 + ymove,
      distance: 50,
      anchor: 'right',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.konv.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 75,
      top: 62 + ymove,
      distance: 50,
      anchor: 'right',
      content: <Annotation colorMode={colorMode}>{Labels.konv.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 67,
      top: 46 + ymove,
      anchor: 'right',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_Konventionell_Medium: AnnotationType[] = [
    {
      left: 53,
      top: 27 + ymove,
      anchor: 'top',
      distance:90,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 200 }}
        >
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 48,
      top: 29 + ymove,
      anchor: 'top',
      distance: 90,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth:150 }}
        >
          {Labels.konv.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 76,
      top: 57 + ymove,
      distance: 40,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.konv.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 46,
      top: 50 + ymove,
      distance: 80,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.konv.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 18,
      top: 42 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.drink}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 67,
      top: 25 + ymove,
      anchor: 'right',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_Konventionell_Small: AnnotationType[] = [
    {
      left: 59,
      top: 29 + ymove,
      anchor: 'top',
      distance: 70,
      content: (
        <Annotation
          colorMode={colorMode}
          align='left'
          style={{ minWidth: 130 }}
        >
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 53,
      top: 31 + ymove,
      anchor: 'top',
      distance: 95,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 150 }}
        >
          {Labels.konv.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 76,
      top: 57 + ymove,
      distance: 40,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.konv.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 44,
      top: 49 + ymove,
      distance: 60,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.konv.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 35,
      top: 44 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.konv.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 81,
      top: 31 + ymove,
      anchor: 'bottom',
      distance: 20,
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_Bio: AnnotationType[] = [
    {
      left: 38,
      top: 64 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 15,
      top: 41 + ymove,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.weide}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 55,
      top: 45 + ymove,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.bio.gitter}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 52,
      top: 48 + ymove,
      anchor: 'top',
      distance: 170,
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 150 }}
          align='right'
        >
          {Labels.bio.scharr}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 80,
      top: 32 + ymove,
      distance: 50,
      anchor: 'right',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.bio.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 49,
      top: 50 + ymove,
      distance: 55,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.klima}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 80,
      top: 52 + ymove,
      distance: 50,
      anchor: 'right',
      content: <Annotation colorMode={colorMode}>{Labels.bio.trog}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 45 + ymove,
      anchor: 'right',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_Bio_Medium: AnnotationType[] = [
    {
      left: 18,
      top: 52 + ymove,
      anchor: 'bottom',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 76,
      top: 57 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.weide}</Annotation>
      ),
    },
    {
      left: 52,
      top: 28 + ymove,
      distance: 100,

      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.bio.gitter}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 30 + ymove,
      distance: 97,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          style={{ minWidth: 120 }}
          align='right'
        >
          {Labels.bio.scharr}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 74,
      top: 70 + ymove,
      distance: 0,
      anchor: 'right',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.bio.nest}
        </Annotation>
      ),
    },
    {
      left: 42,
      top: 33 + ymove,
      distance: 60,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.klima}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 30,
      top: 68 + ymove,
      distance: 40,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.bio.trog}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 72,
      top: 26 + ymove,
      anchor: 'right',
      distance: 55,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_Bio_Small: AnnotationType[] = [
    {
      left: 15,
      top: 36 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.weide}</Annotation>
      ),
    },
    {
      left: 60,
      top: 28 + ymove,
      distance: 80,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 80 }}>
          {Labels.bio.gitter}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 71,
      top: 65 + ymove,
      distance: 35,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.bio.nest}
        </Annotation>
      ),
    },
    {
      left: 49,
      top: 33 + ymove,
      distance: 120,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ maxWidth: 80 }}
        >
          {Labels.bio.klima}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 32,
      top: 55 + ymove,
      distance: 60,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.bio.trog}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 4,
      top: 50 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 76,
      top: 29 + ymove,
      anchor: 'bottom',
      distance: 65,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_EU: AnnotationType[] = [
    {
      left: 42,
      top: 59 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.eu.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },

    {
      left: 57,
      top: 45 + ymove,
      anchor: 'top',
      distance: 140,
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {' '}
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 81,
      top: 32 + ymove,
      distance: 50,
      anchor: 'right',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.eu.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 54,
      top: 47.5 + ymove,
      distance: 140,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 120 }}
        >
          {Labels.eu.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 72,
      top: 57 + ymove,
      distance: 50,
      anchor: 'right',
      content: <Annotation colorMode={colorMode}>{Labels.eu.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 66,
      top: 45 + ymove,
      anchor: 'right',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.eu.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_EU_Medium: AnnotationType[] = [
    {
      left: 32,
      top: 41 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.eu.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },

    {
      left: 54,
      top: 26 + ymove,
      distance: 80,

      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 60 + ymove,
      distance: 40,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.eu.nest}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 49,
      top: 28 + ymove,
      distance: 80,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 100 }}
        >
          {Labels.eu.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 75,
      top: 42 + ymove,
      distance: 40,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.eu.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 72,
      top: 26 + ymove,
      anchor: 'right',
      distance: 55,
      content: (
        <Annotation colorMode={colorMode}>{Labels.eu.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const Annotations_EU_Small: AnnotationType[] = [
    {
      left: 60,
      top: 28 + ymove,
      distance: 80,

      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 80 }}>
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 71,
      top: 51 + ymove,
      distance: 50,
      anchor: 'bottom',
      connect: true,
      connector,
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: '100px' }}>
          {Labels.eu.nest}
        </Annotation>
      ),
    },
    {
      left: 54,
      top: 30 + ymove,
      distance: 85,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 80 }}
        >
          {Labels.eu.einstreu}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 40,
      top: 41 + ymove,
      distance: 60,
      anchor: 'bottom',
      content: <Annotation colorMode={colorMode}>{Labels.eu.eat}</Annotation>,
      connect: true,
      connector,
    },
    {
      left: 23,
      top: 37 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.eu.drink}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 78,
      top: 30 + ymove,
      anchor: 'bottom',
      distance: 40,
      content: (
        <Annotation colorMode={colorMode}>{Labels.eu.stange}</Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  if (standards === 'eu')
    return width > 831
      ? Annotations_EU
      : width > 542
      ? Annotations_EU_Medium
      : Annotations_EU_Small
  if (standards === 'bio')
    return width > 831
      ? Annotations_Bio
      : width > 542
      ? Annotations_Bio_Medium
      : Annotations_Bio_Small
  if (standards === 'konventionell')
    return width > 831
      ? Annotations_Konventionell
      : width > 542
      ? Annotations_Konventionell_Medium
      : Annotations_Konventionell_Small
}
